<template>
    <div>
        <div class="container">
            <div class="progressbar" :style="{width: progress+'%'}"></div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "DashboardProgressbar",
        props: {
            progress: {
                type: Number,
                required: true
            }
        }
    }
</script>

<style lang="scss" scoped>
    .container{
        width:100%;
        height:10px;
        position: relative;
        background: $lightGrey;
    }
    .progressbar{
        transition: width 500ms;
        position: absolute;
        width:0%;
        height:100%;
        left:0;
        top:0;
        background: rgb(117, 43, 119);
        background: -moz-linear-gradient(90deg, $pink 0%, $purple 100%);
        background: -webkit-linear-gradient(90deg, $pink 0%, $purple 100%);
        background-image: -webkit-linear-gradient(90deg, $pink 0%, $purple 100%);
        background: linear-gradient(90deg, $pink 0%, $purple 100%);
        filter: progid:DXImageTransform.Microsoft.gradient(startColorstr="#d70364", endColorstr="#752b77", GradientType=1);
    }
</style>